import { render, staticRenderFns } from "./ProductsCategorySelected.vue?vue&type=template&id=41988172&scoped=true"
import script from "./ProductsCategorySelected.vue?vue&type=script&lang=js"
export * from "./ProductsCategorySelected.vue?vue&type=script&lang=js"
import style0 from "./ProductsCategorySelected.vue?vue&type=style&index=0&id=41988172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41988172",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WarningProductsMidia: require('/home/luiz/Sistemas/loja/components/WarningProductsMidia.vue').default})
